import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getEtfHoldings } from "./etf.api";
import { ETF_HOLDINGS_PAGE_SIZE } from "./etf.type";

export const etfKeys = {
  all: ["etf"] as const,
  holdings: (ticker: string, page: number) => [...etfKeys.all, "holdings", ticker, page] as const,
};

/** One page of a fund's basket; the first page is seeded by the server loader. */
export const useEtfHoldings = (ticker: string, page: number) =>
  useQuery({
    queryKey: etfKeys.holdings(ticker, page),
    queryFn: ({ signal }) => getEtfHoldings(ticker, page, ETF_HOLDINGS_PAGE_SIZE, { signal }),
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
